/**
 * subscriptionsAdminMixin — retained for backward compatibility.
 *
 * The Admin-bypass logic that was previously duplicated here (checking only
 * roles[0] and only for subscriptions.* permissions) has been removed.
 * The global canMixin now handles Admin/owner bypass for ALL modules and ALL
 * roles in the array, so this mixin no longer needs to override can().
 */
export default {
  // Intentionally empty — relies on global canMixin registered in app.js
};
